import styles from "./spinners.module.scss";

const white = "white";
// eslint-disable-next-line no-unused-vars
// const black = "black";

export default function Spinner(props: any) {
  const { color = "white", className = "" } = props;
  return (
    <div>

      <div className={color === white ? `${styles.sk_fading_circle} ${className}` : `${styles.sk_fading_circle} ${styles.black_circles} ${className}`}>
        {
          [...Array(11)].map((_, index) => <div key={index} className={`${styles[`sk_circle${index + 1}`]} ${styles.sk_circle}`} />)
        }
      </div>
    </div>
  );
}
